import { PNL_TONE_TEXT } from '@/lib/ui/wealth-tone';
import { cn } from '@/lib/utils';

interface PnLIndicatorProps {
  amount: number;
  formatted: string;
  className?: string;
}

function direction(amount: number): 'gain' | 'loss' | 'flat' {
  if (amount > 0) return 'gain';
  if (amount < 0) return 'loss';
  return 'flat';
}

export function PnLIndicator({ amount, formatted, className }: PnLIndicatorProps) {
  return (
    <span className={cn('font-medium tabular-nums', PNL_TONE_TEXT[direction(amount)], className)}>
      {formatted}
    </span>
  );
}
